import IndustrySelector from './industry-selector';

export default IndustrySelector;
